// src/components/AchievementBadges.js
import React, { useMemo } from 'react';
import { Flame, TrendingUp, Crown, Target, Zap, UsersRound, CalendarCheck } from 'lucide-react';
import { computePlayerAchievements, RARITY_CONFIG } from '../utils/achievementCalculations';

export const ICON_MAP = { Flame, TrendingUp, Crown, Target, Zap, UsersRound, CalendarCheck };

export default function AchievementBadges({ player, matches }) {
  const achievements = useMemo(
    () => computePlayerAchievements(player, matches),
    [player, matches]
  );

  if (achievements.length === 0) return null;

  return (
    <div className="bg-card rounded-lg border border-border p-4">
      <p className="text-xs font-medium text-muted-foreground mb-3">업적 뱃지</p>
      <div className="flex flex-wrap gap-1.5">
        {achievements.map(a => {
          const Icon = ICON_MAP[a.icon];
          const rarity = RARITY_CONFIG[a.rarity];
          return (
            <div
              key={a.id}
              className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border ${a.bgColor} ${a.color} ${rarity?.border || a.borderColor} transition-colors`}
              title={`${a.description} (${rarity?.label || 'Normal'})`}
            >
              {Icon && <Icon className="h-3 w-3" />}
              {a.label}
            </div>
          );
        })}
      </div>
    </div>
  );
}
